import { gql } from "@apollo/client";

export {
  GET_TICKET_ENDPOINT_KEYS,
  GET_TICKET_MANAGERS,
  GET_TICKET_TEMPLATES_SUMMARY,
  GET_TICKET_TEMPLATE_SUMMARY,
  DELETE_TICKET_TEMPLATE,
  generateGetTicketEndpointKeys,
} from "@SeemplicityDev/ticket-master";

export const UPDATE_FINDING_TICKETS_CACHE = gql`
  fragment Tickets on FindingsView {
    tickets {
      edges {
        node {
          id
          status
          external_status
          external_id
          ticket_due_date_remaining_time
          ticket_due_date_status
          ticket_assignee_name
          created_by_remediation_queue_id
          created_by
          created_time
          remediation_queue_title
          due_date
          age
          ticket_provider {
            known_identifier
            type
          }
        }
      }
    }
  }
`;

export const REOPEN_TICKETS = gql`
  mutation reopenTickets(
    $filters_config: FiltersConfigInput!
    $apply_sync: Boolean
  ) {
    reopen_tickets(filters_config: $filters_config, apply_sync: $apply_sync) {
      task_id
    }
  }
`;

export const ELIGIBLE_FOR_REOPEN_AMOUNT = gql`
  query EligibleForReopenTicketFindings($filters_config: FiltersConfigInput!) {
    eligible_for_reopen_ticket_findings(filters_config: $filters_config) {
      eligible_for_reopen_ticket_findings_amount
    }
  }
`;

export const DETACH_TICKETS = gql`
  mutation detachTickets($ticket_ids: [ID]!) {
    detach_tickets(ticket_ids: $ticket_ids) {
      ok
    }
  }
`;
